import { requestsLikeGenerate } from "../../../plugins/python/requestsLike.js";
const pythonHttpxSync = {
  target: "python",
  client: "httpx_sync",
  title: "HTTPX (Sync)",
  generate(request, configuration) {
    return requestsLikeGenerate("httpx", request, configuration);
  }
};
export {
  pythonHttpxSync
};
//# sourceMappingURL=sync.js.map
